import { Model } from "@models";

export class AssetInfo extends Model {
	private description: string = "";
	private info: string = "";
	private info_integration: string = "";
	private extra_info: string = "";

	public getDescription(): string {
		return this.description;
	}

	public getInfo(): string {
		return this.info;
	}

	public getInfoIntegration(): string {
		return this.info_integration;
	}

	public getExtraInfo(): string {
		return this.extra_info;
	}
}
